import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'request-training',
  templateUrl: './request-training.component.html',
  styleUrls: ['./request-training.component.scss']
})
export class RequestTrainingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
